import * as tslib_1 from "tslib";
import "../../CommonImports";
import "../../Core/core.css";
import "./Header.css";
import * as React from "react";
import { css } from '../../Util';
var HeaderDescription = /** @class */ (function (_super) {
    tslib_1.__extends(HeaderDescription, _super);
    function HeaderDescription() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    HeaderDescription.prototype.render = function () {
        return React.createElement("div", { className: css(this.props.className, "bolt-header-description body-m secondary-text") }, this.props.children);
    };
    return HeaderDescription;
}(React.Component));
export { HeaderDescription };
